(function () {
  'use strict';

  var COOKIE_NAME = 'duxbux_brand';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 30;
  var VALID_BRANDS = ['dux', 'bux'];

  function isBrand(value) {
    return VALID_BRANDS.indexOf(value) !== -1;
  }

  function getCookie(name) {
    var prefix = name + '=';
    var cookie = document.cookie
      .split(';')
      .map(function (part) { return part.trim(); })
      .find(function (part) { return part.indexOf(prefix) === 0; });

    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : '';
  }

  function setBrandCookie(brand) {
    if (!isBrand(brand)) return;

    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(brand)
      + '; Path=/; Max-Age=' + COOKIE_MAX_AGE + '; SameSite=Lax' + secure;
  }

  function track(eventName, detail) {
    var payload = Object.assign({ event: eventName }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('duxbux:' + eventName, { detail: payload }));
  }

  function withQuery(url, key, value) {
    var nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set(key, value);
    return nextUrl.pathname + nextUrl.search + nextUrl.hash;
  }

  function initializeGateway(preferredBrand) {
    var gateway = document.querySelector('[data-brand-gateway]');
    if (!gateway) return;

    track('chooser_viewed', { preferred_brand: preferredBrand || 'none' });

    var params = new URLSearchParams(window.location.search);
    var explicitBrand = params.get('brand');

    if (isBrand(explicitBrand)) {
      setBrandCookie(explicitBrand);
      track('brand_selected', { brand: explicitBrand, source: 'direct_link' });
      window.location.replace(gateway.getAttribute('data-' + explicitBrand + '-url'));
      return;
    }

    if (isBrand(preferredBrand) && !window.Shopify.designMode) {
      window.location.replace(gateway.getAttribute('data-' + preferredBrand + '-url'));
    }
  }

  function initializeBrandLinks(currentBrand) {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.js-brand-select');
      if (!link) return;

      var selectedBrand = link.getAttribute('data-brand-select');
      if (!isBrand(selectedBrand)) return;

      setBrandCookie(selectedBrand);
      track(currentBrand && currentBrand !== 'shared' && currentBrand !== selectedBrand
        ? 'brand_switched'
        : 'brand_selected', {
        brand: selectedBrand,
        previous_brand: currentBrand || 'shared',
        destination: link.href
      });
    });
  }

  function initializeSearch() {
    var scopeNav = document.querySelector('[data-search-scopes]');
    if (!scopeNav) return;
    var params = new URLSearchParams(window.location.search);
    // A saved storefront brand must not narrow a fresh catalog search.
    var activeScope = params.get('brand') || 'all';

    if (!isBrand(activeScope)) activeScope = 'all';

    scopeNav.querySelectorAll('[data-search-scope]').forEach(function (scopeLink) {
      var isActive = scopeLink.getAttribute('data-search-scope') === activeScope;
      scopeLink.classList.toggle('is-active', isActive);
      if (isActive) {
        scopeLink.setAttribute('aria-current', 'page');
      } else {
        scopeLink.removeAttribute('aria-current');
      }
    });

    var visibleProducts = 0;
    document.querySelectorAll('#filter-results product-card[data-product-brand]').forEach(function (card) {
      var result = card.closest('.js-pagination-result');
      var productBrand = card.getAttribute('data-product-brand');
      var visible = activeScope === 'all'
        || productBrand === activeScope
        || productBrand === 'shared';

      if (result) result.hidden = !visible;
      if (visible) visibleProducts += 1;
    });

    var emptyState = document.querySelector('[data-search-scope-empty]');
    if (emptyState) emptyState.classList.toggle('hidden', visibleProducts > 0);

    scopeNav.addEventListener('click', function (event) {
      var scopeLink = event.target.closest('[data-search-scope]');
      if (!scopeLink) return;

      track('search_scope_changed', {
        scope: scopeLink.getAttribute('data-search-scope'),
        query: scopeNav.getAttribute('data-search-query') || ''
      });
    });
  }

  function initializeCommerceTracking() {
    if (document.body.getAttribute('data-page-type') === 'product') {
      track('product_viewed', {
        product_id: document.body.getAttribute('data-product-id') || '',
        brand: document.body.getAttribute('data-brand') || 'shared'
      });
    }

    document.addEventListener('click', function (event) {
      var crossSell = event.target.closest(
        '#cart-drawer .cart-recommendations a, #cart-drawer #cart-promoted-products a'
      );
      if (crossSell) {
        track('cart_cross_sell', {
          destination: crossSell.href || '',
          product_id: crossSell.closest('[data-product-id]')
            ? crossSell.closest('[data-product-id]').getAttribute('data-product-id')
            : ''
        });
      }

      var quickAdd = event.target.closest(
        '.js-quick-add, [data-inline-quick-shop-toggle], product-card [name="add"]'
      );
      if (quickAdd) {
        var card = quickAdd.closest('product-card');
        track('quick_add', {
          product_id: card ? card.getAttribute('data-product-id') : '',
          brand: card ? card.getAttribute('data-product-brand') : ''
        });
      }

      var checkout = event.target.closest('[name="checkout"], a[href*="/checkout"]');
      if (checkout) track('checkout_start', {});
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      var card = form.closest('product-card');
      track('add_to_cart', {
        product_id: card ? card.getAttribute('data-product-id') : '',
        brand: card ? card.getAttribute('data-product-brand') : document.body.getAttribute('data-brand')
      });
    });
  }

  function initialize() {
    var body = document.body;
    var currentBrand = body.getAttribute('data-brand') || 'shared';
    var preferredBrand = getCookie(COOKIE_NAME);

    if (isBrand(preferredBrand)) {
      body.setAttribute('data-preferred-brand', preferredBrand);
      body.classList.add('brand-preference--' + preferredBrand);
    }

    if (isBrand(currentBrand)) setBrandCookie(currentBrand);

    initializeBrandLinks(currentBrand);
    initializeGateway(preferredBrand);
    initializeSearch();
    initializeCommerceTracking();
  }

  window.DUXBUX = window.DUXBUX || {};
  window.DUXBUX.getBrand = function () { return getCookie(COOKIE_NAME); };
  window.DUXBUX.setBrand = setBrandCookie;
  window.DUXBUX.track = track;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
}());
